import { MessageThread } from '../services/MessagingService';

export const getThreadTitle = (thread: MessageThread) => {
  return thread.title || `Wątek ${thread.id}`;
};
